module.exports = __webpack_public_path__ + "img/port.c6937314.png";